var store = {
  state: {
    query: {},
    errorType: null,  // soldOut, noDates, datesPast, datesApart, datesMismatch
    startSelect: '',
    endSelect: '',
    dstTypeSelect: '',
    dstIdSelect: '',
    dstStringSelect: '',
    sort: '',
    today: dataLayer[0].currentDate || '',
    totalRooms: dataLayer[0].rooms || 1,
    currency: 'USD',
    country: dataLayer[0].country || 'us',
    destinationString: dataLayer[0].dsts || '',
    destinationType: dataLayer[0].dstt || '',
    destinationIndex: dataLayer[0].dsti || '',
    currencyDisplay: {
      currencyInFront: true,
      groupingSeparator: ' ',
      decimalSeparator: '.',
      currencySpace: true
    },
    nightlyRates: true,
    syncCalendars: [],
    locale: dataLayer[0].locale || '',
    pageType: dataLayer[0].custompage,
    rtl: dataLayer[0].rtl || false,
    searchTheme: dataLayer[0].searchTheme || '',
    maximumDiscountHTML: '',
    siteLink: '',
    device: dataLayer[0].device || 'desktop',
    hotel: {
      id: dataLayer[0].hotel_hotelid || 0,
      rank: dataLayer[0].hotel_rank || 0,
      typeId: dataLayer[0].hoteltype_id || 0
    }
  },
  set: function(key, value) {
    if (debug) console.log('set state '+ key+' to', value);
    if (key.indexOf('.') != -1) {
      this.state[key.split('.')[0]][key.split('.')[1]] = value;
    } else {
      this.state[key] = value;
    }
  }
};

function retrieveQueryObj() {
    // get query from url
    var urlQ = $url.getVar('q'),
        query = urlQ ? $url.decodeQ(urlQ) : null,
        urlCur = $url.getVar('cur');

    if (!query) {
      // or get query config from prs cookie
      var prs = $cookie.decodePrs($cookie.get('prs') || $cookie.get('prsps'));
      query = prs && prs.q ? $url.decodeQ(prs.q) : null;
    }

    // currency set as get var overrules the q get var
    store.set('currency', (urlCur || query ? query.cur : null) || 'USD');

    if (query && urlCur) {
      query.cur = urlCur;
    }
    if (query && store.state.searchTheme && win.searchThemesIds[store.state.searchTheme]) {
      query.fac |= win.searchThemesIds[store.state.searchTheme];
    }
    if (query) {
      if (debug) window.console.log('retrieveQueryObj');
      store.set('query', query);
    }

}

function setSiteLink() {
  var sl = $url.getVar('sl');
  var siteLinks = {
    6: 'checkAvailability',
    7: 'hotelReviews',
    8: 'hotelMap',
    9: 'hotelPhotos',
    10: 'hotelPolicies',
    11: 'hotelAmenities',
    12: 'bookTonight',
    13: 'bookTomorrow'
  };
  if (sl) store.set('siteLink', siteLinks[sl]);
}

function initStore() {
  retrieveQueryObj();  
  setSiteLink();
}

initStore();